
// import { v4 as uuidv4 } from 'uuid';
import { types } from '../types/types';
import { fetchConToken } from '../../helpers/fetch';

import { initialCreateHito, initialCreateHitoModeAbo, initialCreateHitoModeAmo, initialCreateHitoModeVal, initialCreateProject, initialCreateTask } from '../../helpers/project'
import { startOpenProgress } from '../actions/general'

import { toast } from 'react-toastify'

export const iniCreateProject = () => {
    return async (dispatch, getState) => {
        try {

            const initialParams = getState().general.detail
            const newDetail = await initialCreateProject(initialParams)
            dispatch(projectLoadDetail(newDetail))

        } catch (error) {
            console.log(error);
            toast.error(error)
        }
    }
}

export const iniLoadProject = (filters) => {
    return async (dispatch) => {

        try {

            const params = (new URLSearchParams(filters)).toString()
            const resp = await fetchConToken(`projects/pptos/tarea/?${params}`);
            const body = await resp.json();

            if (body.ok) {
                dispatch(projectLoadList(body.data));
            }

        } catch (error) {
            console.log(error)
        }

    }
}

export const iniLoadProjectDetail = (projectId) => {
    return async (dispatch) => {
        try {

            dispatch(startOpenProgress(true))

            const resp = await fetchConToken(`projects/${projectId}`)
            const body = await resp.json()
            if (body.ok) {
                dispatch(projectLoadDetail(body.data))
            }

            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(true))
        }
    }
}

export const iniSaveProject = (formData, navigate) => {
    return async (dispatch, getState) => {
        try {

            dispatch(startOpenProgress(true))

            const resp = await fetchConToken('projects', formData, 'POST');
            const body = await resp.json();
            if (body.ok) {

                if (body.ok) {
                    toast.success(body.msg);

                    const newIds = {
                        id: body.data.id,
                        numero: body.data.numero
                    }

                    dispatch(projectSetNewIds(newIds));
                    navigate(`/proyectos/info/${body.data.id}`)

                } else {
                    toast.warning(body.msg);
                }
            }

            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(false))
        }
    }
}

export const iniUpdateProject = (formData, projectId) => {
    return async (dispatch) => {
        try {

            dispatch(startOpenProgress(true))

            const { id } = formData

            const resp = await fetchConToken(`projects/${projectId}`, formData, 'PUT')
            const body = await resp.json()

            if (body.ok) {
                if (id) {
                    dispatch(iniLoadProjectDetail(id))
                }
                toast.success(body.msg);
            } else {
                toast.warning(body.msg);
            }

            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(false))
        }
    }
}

export const iniSaveTask = (detailProject) => {
    return async (dispatch) => {
        try {

            dispatch(startOpenProgress(true))

            const dataForm = {
                project_id: detailProject.id,
                tasks: detailProject.hitos
            }

            const resp = await fetchConToken(`tasks/projects/${detailProject.id}`, dataForm, 'PUT');
            const body = await resp.json();
            if (body.ok) {

                if (body.ok) {
                    toast.success(body.msg);

                    // dispatch(projectSetNewIds(newIds));

                } else {
                    toast.warning(body.msg);
                }
            }

            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(false))
        }
    }
}

export const iniLocalSave = (detailTask) => {
    return async (dispatch, getState) => {
        try {

            // dispatch(startOpenProgress(true))

            const resp = await fetchConToken('tasks', detailTask, 'POST');
            const body = await resp.json();
            if (body.ok) {

                if (body.ok) {
                    toast.success(body.msg);

                    const newIds = {
                        id: body.data.id
                    }

                    dispatch(projectSetNewIds(newIds));

                } else {
                    toast.warning(body.msg);
                }
            }

            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(false))
        }
    }
}


// TASK
export const iniAddHito = (infoHito, taskName = null) => {
    return async (dispatch, getState) => {
        try {

            const hitosList = getState().project.detail.hitos
            const newHito = await initialCreateHito(hitosList, taskName)
            dispatch(hitoAdd(newHito))

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    }
}

// TASK mode valorizacion
export const iniAddHitoModeVal = (cantVal = null) => {
    return async (dispatch, getState) => {
        try {

            const detailProject = getState().project.detail
            const hitosList = detailProject.hitos

            // Valorizacion
            const newHitosVal = await initialCreateHitoModeVal(hitosList, cantVal, detailProject)
            dispatch(hitoAdd(newHitosVal))

            // Amortización
            const newHitosAmo = await initialCreateHitoModeAmo(hitosList, cantVal, detailProject)
            dispatch(hitoAdd(newHitosAmo))

            // Abono
            const newHitosAbo = await initialCreateHitoModeAbo(hitosList, cantVal, detailProject)
            dispatch(hitoAdd(newHitosAbo))


        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    }
}

export const iniAddTask = (infoHito, taskName = null) => {
    return async (dispatch, getState) => {
        try {

            const hitos = getState().project.detail.hitos
            const newTask = await initialCreateTask(infoHito, taskName)

            const updatedList = hitos.map(hito => {
                if (hito.id === infoHito.id) {
                    return {
                        ...hito,
                        tasks: [...hito.tasks, newTask]
                    }
                }
                return hito
            })

            dispatch(setAllHitos(updatedList))

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    }
}

export const iniRemoveHitos = (hitoId) => {
    return async (dispatch, getState) => {
        try {

            const hitosList = getState().project.detail.hitos
            const hitosUpdated = hitosList.map(hito => {
                if (hito.id === hitoId) {
                    return {
                        ...hito,
                        delete: true
                    }
                }
                return hito
            })

            dispatch(setAllHitos(hitosUpdated))

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    }
}

export const iniRemoveTask = (infoTask) => {
    return async (dispatch, getState) => {
        try {

            const hitosList = getState().project.detail.hitos

            const hitosUpdated = hitosList?.map(hito => {
                if (hito.id === infoTask.id_hito) {
                    const hitosTaskUpdated = hito.tasks.map(task => {
                        if (task.id === infoTask.id) {
                            return {
                                ...task,
                                delete: true
                            }
                        }
                        return task
                    })

                    return {
                        ...hito,
                        tasks: hitosTaskUpdated
                    }
                }

                return hito
            })

            dispatch(setAllHitos(hitosUpdated))

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    }
}

export const iniEditTask = (dataForm, infoTask, changedInFlow = null) => {
    return async (dispatch, getState) => {
        try {

            const hitos = getState().project.detail.hitos

            const editSetTask = async () => {
                const updatedList = hitos.map(hito => {
                    if (hito.id === infoTask.id_hito) {
                        const updatedTasks = hito.tasks.map(task => {
                            if (task.id === infoTask.id) {
                                return dataForm
                            }
                            return task
                        })

                        return {
                            ...hito,
                            tasks: updatedTasks
                        }

                    }

                    return hito
                })

                dispatch(setAllHitos(updatedList))

            }

            const editSetHito = async () => {

                const updatedList = hitos.map(hito => {

                    if (hito.id === infoTask.id) {

                        if (changedInFlow) {
                            const updatedTasks = hito.tasks.map(task => {
                                return {
                                    ...task,
                                    in_flow_operacion: dataForm.in_flow_operacion
                                }
                            })

                            return {
                                ...hito,
                                in_flow_operacion: dataForm.in_flow_operacion,
                                tasks: updatedTasks
                            }

                        } else {

                            return dataForm

                        }

                    }


                    return hito

                })

                dispatch(setAllHitos(updatedList))

            }

            if (infoTask.tipo === 'hito') {
                await editSetHito()
            } else {
                await editSetTask()
            }

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    }
}

export const iniEditTaskFromRow = (dataForm, infoTask, colName) => {
    return async (dispatch, getState) => {
        try {

            const hitos = getState().project.detail.hitos

            const updatedList = hitos.map(hito => {
                if (hito.id === infoTask.id_hito) {

                    const updatedTasks = hito.tasks.map(task => {
                        if (task.id === infoTask.id) {

                            if (colName !== 'id_responsable' && colName !== 'estado' && colName !== 'fecha_inicio') {
                                return {
                                    ...task,
                                    [colName]: dataForm[colName]
                                }
                            }

                            if (colName === 'fecha_inicio') {
                                return {
                                    ...task,
                                    fecha_inicio: dataForm.fecha_inicio,
                                    fecha_fin: dataForm.fecha_fin
                                }
                            }

                            if (colName === 'estado') {
                                return {
                                    ...task,
                                    [colName]: dataForm[colName],
                                    'porcentaje_avance': (dataForm.estado === 'completado' ? 100 : 0)
                                }
                            }

                            if (colName === 'id_responsable') {
                                return {
                                    ...task,
                                    [colName]: dataForm[colName],
                                    'responsable': dataForm.responsable
                                }
                            }

                        }

                        return task
                    })

                    return {
                        ...hito,
                        tasks: updatedTasks
                    }

                }

                return hito

            })

            dispatch(setAllHitos(updatedList))

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    }
}

export const iniEditAllTaskFlow = (hitoEdit, newStatus) => {
    return async (dispatch, getState) => {
        try {

            const hitos = getState().project.detail.hitos

            const updatedList = hitos.map(hito => {
                if (parseFloat(hito.id) === parseFloat(hitoEdit.id)) {

                    const updatedStatusTasks = hito.tasks.map(task => {
                        return {
                            ...task,
                            in_flow: newStatus
                        }
                    })

                    return {
                        ...hito,
                        in_flow: newStatus,
                        tasks: updatedStatusTasks
                    }

                }

                return hito

            })

            dispatch(setAllHitos(updatedList))

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    }
}

const projectSetNewIds = (newIds) => ({
    type: types.projectSetNewId,
    payload: newIds
})

const projectLoadDetail = (projectDetail) => ({
    type: types.projectLoadDetail,
    payload: projectDetail
})

const projectLoadList = (projects) => ({
    type: types.projectLoadList,
    payload: projects
})

// const projectSetNewId = (newId) => ({
//     type: types.projectSetNewId,
//     payload: newId
// })

export const iniProjectStatusSavedCloud = (status) => ({
    type: types.projectSavedCloud,
    payload: status
})


// TAREAS

const hitoAdd = (newHito) => ({
    type: types.hitoAdd,
    payload: newHito
})

const setAllHitos = (hitosList) => ({
    type: types.setAllHitos,
    payload: hitosList
})

// const taskAdd = (newAdd) => ({
//     type: types.taskAdd,
//     payload: newAdd
// })